import { render, staticRenderFns } from "./customer_manage_tpl.vue?vue&type=template&id=f759ce78&scoped=true&"
import script from "./customer_manage_tpl.vue?vue&type=script&lang=js&"
export * from "./customer_manage_tpl.vue?vue&type=script&lang=js&"
import style0 from "./customer_manage_tpl.vue?vue&type=style&index=0&id=f759ce78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f759ce78",
  null
  
)

export default component.exports